// Local persistence — the React equivalent of the Flutter app's file_op.dart
// (userdata + login flag). Uses localStorage.

const USER_KEY = 'sli_user_data';
const LOGIN_KEY = 'sli_is_logged';

export function saveUserData(userArray) {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(userArray));
    localStorage.setItem(LOGIN_KEY, '1');
  } catch (e) {
    console.error('saveUserData', e);
  }
}

export function loadUserData() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function isLoggedIn() {
  return localStorage.getItem(LOGIN_KEY) === '1' && !!loadUserData();
}

export function clearSession() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(LOGIN_KEY);
}
